// extracted by mini-css-extract-plugin
module.exports = {"menus":"Menus-loader__menus___1FZbc","fake":"Menus-loader__fake___25Jel","fakeItem":"Menus-loader__fakeItem___3dVQR"};